export default {
  businessLogisticsCompanyBusiness: {
    header: {
      name: 'Courier Service Name',
    },
    table: {
      name: 'Courier Service Code',
      full: 'Courier Service Name',
      abbreviation: 'Courier Service Code',
      priority: 'Priority',
      DefaultMarkup: 'Default Markup (Tax excl.)',
      ProfitMargin: 'Profit Margin (excl. GST)',
      errTip: 'Please enter a value greater than 0 and less than 100',
      maxL: 'Maximum Length',
      maxW: 'Maximum Dead Weight',
      maxVw: 'Maximum Cubic Weight',
    },
    dialog: {
      businessPlaceholder: 'Please enter business name',
      priorityMessage: 'The smaller the value, the higher the priority.',
      priorityRulesMsg: 'Please enter the priority'
    },
    setting: {
      title: 'Delivery Channel Settings',
      channelCode: 'Channel Code',
      channelName: 'Channel Name',
      logisticsChannelType: 'Logistics Channel Type',
      supplier: 'Supplier',
      status: 'Status',
      createdOn: 'Created On',
      channelRules: 'Channel Rules',
      labelRules: 'Label Rules',
      deliveryTrackingNumberSettings: 'Delivery Tracking Number Settings',
      zones: 'Zones',
      trackingDataFetchSettings: 'Tracking Data Fetch Settings',
      serviceZones: 'Ordinary Zone',
      remoteZones: 'Remote Zones',
    },
  },
};

